import DegenChat from './degenChat.js';
import "./App.css";

function App() {
  return <DegenChat />;
}

export default App;

